import { render, staticRenderFns } from "./updatePwd.vue?vue&type=template&id=2e8f19aa&scoped=true&"
import script from "./updatePwd.vue?vue&type=script&lang=ts&"
export * from "./updatePwd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f19aa",
  null
  
)

export default component.exports